import { Params } from 'react-router-dom';
import { Crumb, RouteHandle } from '@shared/shell/types';
import { SuiteManifest } from '@suites/manifest';

export type { Crumb };

export interface RouteMatchLike {
  id: string;
  pathname: string;
  params: Params<string>;
  data: unknown;
  handle?: unknown;
}

export function buildCrumbs(
  matches: RouteMatchLike[],
  activeSuite?: SuiteManifest,
  overrides: Record<string, string> = {}
): Crumb[] {
  const crumbs: Crumb[] = [];

  // First crumb: active suite
  if (activeSuite) {
    const isAtSuiteRoot = matches.some(
      (m) => m.pathname.replace(/\/+$/, '') === activeSuite.basePath
    );
    crumbs.push({
      label: activeSuite.name,
      to: isAtSuiteRoot ? undefined : activeSuite.basePath,
    });
  }

  // Intermediate and leaf route crumbs
  for (const match of matches) {
    const handle = match.handle as RouteHandle | undefined;
    const normalizedPath = match.pathname.replace(/\/+$/, '') || '/';
    const overrideLabel = overrides[normalizedPath];

    const label = overrideLabel || handle?.crumb;
    if (!label) continue;

    // Avoid consecutive duplicate crumb labels
    if (crumbs.length > 0 && crumbs[crumbs.length - 1].label === label) {
      continue;
    }

    crumbs.push({
      label,
      to: match.pathname,
    });
  }

  // The last crumb is the active leaf page — no navigation link
  if (crumbs.length > 0) {
    crumbs[crumbs.length - 1].to = undefined;
  }

  return crumbs;
}
